import React, { useRef, useLayoutEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";

const MultiCarousel = ({ children, carouselSettings, heading, text, customHeader, customText, setDisplayedItems }) => {
    const carouselRef = useRef(null)
    const buttonPrevRef = useRef(null)
    const buttonNextRef = useRef(null)
    const [moreItemsToShow, setMoreItemsToShow] = useState(false)
    const isSmallScreen = useMediaQuery({ maxWidth: 550 })
    const isMediumScreen = useMediaQuery({ minWidth: 764 })
    const isLargeScreen = useMediaQuery({ minWidth: 1024 })
    const isXLargeScreen = useMediaQuery({ minWidth: 1124 })
    const isXXLargeScreen = useMediaQuery({ minWidth: 1400})

    useLayoutEffect(() => {
        setTimeout(() => buttonPrevRef.current != null && (buttonPrevRef.current.disabled = true), 500)
    }, [])

    useLayoutEffect(() => {
        if (carouselRef.current == null || children.length == 0) return
        const { state } = carouselRef.current

        carouselRef.current.goToSlide(0) // If we remove products, then the list may change, and we are on a slide that no longer exists. So we go to the first slide
        setDisplayedItems && setDisplayedItems(1, state.slidesToShow)

        children.length > state.slidesToShow 
            ? setMoreItemsToShow(true)
            : setMoreItemsToShow(false)
    }, [children, carouselRef.current])

    useLayoutEffect(() => {
        // Check if we need to show the arrows
        if (carouselRef.current == null || children.length == 0) return
        const { state } = carouselRef.current;

        children.length > state.slidesToShow 
            ? setMoreItemsToShow(true)
            : setMoreItemsToShow(false)
    }, [isSmallScreen, isMediumScreen, isLargeScreen, isXLargeScreen, isXXLargeScreen])

    function beforeChange(nextSlide, ref) {
        const { slidesToShow, totalItems } = ref
        if (buttonPrevRef.current == null || buttonNextRef.current == null)
            return;

        // Pass the start and end index of the displayed items to the parent component
        setDisplayedItems && setDisplayedItems(nextSlide + 1, nextSlide + slidesToShow)

        if (nextSlide === 0) {
            buttonPrevRef.current.disabled = true;
            buttonNextRef.current.disabled = false;
        }
        else if (nextSlide === totalItems - slidesToShow) {
            buttonPrevRef.current.disabled = false;
            buttonNextRef.current.disabled = true;
        }
        else {
            buttonPrevRef.current.disabled = false;
            buttonNextRef.current.disabled = false;
        }
    }
    
    return (
        <>
            <div className='carousel-header'>
                { 
                    customHeader 
                        ? customHeader
                        : <h2 className='carousel-header__heading'>{ heading }</h2>
                }
                {customText ? customText : <span className='carousel-header__text'>{ text }</span>}
            </div>

            <div className='carousel-wrapper'>

                {
                    moreItemsToShow && (
                        <div className='multi-carousel__arrows'>
                            <button className='multi-carousel__arrow multi-carousel__arrow--left' 
                                onClick={() => carouselRef.current.previous()} ref={buttonPrevRef}>
                            </button>
                            <button className='multi-carousel__arrow multi-carousel__arrow--right' 
                                onClick={() => carouselRef.current.next()} ref={buttonNextRef}>
                            </button>
                        </div>
                    )
                }

                <Carousel 
                    ref={carouselRef} 
                    beforeChange={(nextSlide, ref) => beforeChange(nextSlide, ref)}
                    preventMovementUntilSwipeScrollTolerance={true}
                    swipeScrollTolerance={100}
                    showDots={true}
                    partialVisible={moreItemsToShow}
                    arrows={false}
                    minimumTouchDrag={80}
                    containerClass='multi-carousel'
                    itemClass='multi-carousel__item'
                    renderDotsOutside={true}
                    customDot={<CustomDot />}
                    dotListClass='multi-carousel__dots'
                    {...carouselSettings}>

                    {
                        children
                    }
                </Carousel>
            </div>
        </>
    );
};

const CustomDot = ({ onClick, active }) => {
    return (
        <button className={`multi-carousel__dot ${active ? 'multi-carousel__dot--active' : ''}`} onClick={() => onClick()} />
    )
}


export default MultiCarousel;
